import Config from 'react-native-config';
import {
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherEndpoint,
  DispatcherResource
} from 'modules/types/common';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import { RootDispatch } from 'store/types';
import {
  lowPriorityItemsRequestStateSelector,
  highPriorityItemsRequestStateSelector
} from './selectors';

export const SET_HAS_SENT_DASHBOARD_CARD_ANALYTICS =
  'PRIORITY_ITEMS.SET_HAS_SENT_DASHBOARD_CARD_ANALYTICS';

export const GET_LOW_PRIORITY_ITEMS = 'PRIORITY_ITEMS.GET_LOW_PRIORITY_ITEMS';
export const GET_LOW_PRIORITY_ITEMS_SUCCESS = 'PRIORITY_ITEMS.GET_LOW_PRIORITY_ITEMS_SUCCESS';
export const GET_LOW_PRIORITY_ITEMS_FAIL = 'PRIORITY_ITEMS.GET_LOW_PRIORITY_ITEMS_FAIL';

export const getLowPriorityItems = (useRequestState = true) => (dispatch: RootDispatch) => {
  return dispatch({
    type: GET_LOW_PRIORITY_ITEMS,
    payload: {
      client: 'dispatcher',
      useRequestState,
      requestStateSelector: lowPriorityItemsRequestStateSelector,
      request: {
        method: 'get',
        url: getDispatcherUrl(
          DispatcherCategoryService.SELF,
          DispatcherAuthPrefix.AUTHENTICATED,
          DispatcherResource.ACTION_ITEMS,
          DispatcherEndpoint.LOW_PRIORITY
        )
      }
    }
  });
};

export const GET_HIGH_PRIORITY_ITEMS = 'PRIORITY_ITEMS.GET_HIGH_PRIORITY_ITEMS';
export const GET_HIGH_PRIORITY_ITEMS_SUCCESS = 'PRIORITY_ITEMS.GET_HIGH_PRIORITY_ITEMS_SUCCESS';
export const GET_HIGH_PRIORITY_ITEMS_FAIL = 'PRIORITY_ITEMS.GET_HIGH_PRIORITY_ITEMS_FAIL';

export const getHighPriorityItems = (useRequestState = true) => (dispatch: RootDispatch) => {
  const enableNewUrl = Config.HIGH_PRIORITY_ITEMS_V2 === 'enabled';
  return dispatch({
    type: GET_HIGH_PRIORITY_ITEMS,
    payload: {
      client: 'dispatcher',
      useRequestState,
      requestStateSelector: highPriorityItemsRequestStateSelector,
      request: {
        method: 'get',
        url: getDispatcherUrl(
          DispatcherCategoryService.SELF,
          DispatcherAuthPrefix.AUTHENTICATED,
          DispatcherResource.ACTION_ITEMS,
          enableNewUrl ? DispatcherEndpoint.HIGH_PRIORITY_V2 : DispatcherEndpoint.HIGH_PRIORITY
        )
      }
    }
  });
};
